import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6949ffa8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "group-edit" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "app-component-header__title" }, " Add Members ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_app_search = _resolveComponent("app-search")!
  const _component_add_group_members = _resolveComponent("add-group-members")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_header, null, {
      "top-left": _withCtx(() => [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('on-cancel')), ["prevent"])),
          class: "back-link"
        }, _hoisted_4)
      ]),
      "top-middle": _withCtx(() => [
        _hoisted_5
      ]),
      "top-right": _withCtx(() => [
        _createElementVNode("a", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDone && _ctx.onDone(...args))),
          href: "javascript:void(0);",
          class: "back-link"
        }, " Done ")
      ]),
      _: 1
    }),
    _createVNode(_component_app_search),
    _createVNode(_component_add_group_members, {
      "users-to-add": _ctx.usersToAdd,
      "users-to-invite": _ctx.usersToInvite,
      onUpdateUsers: _ctx.updateUsersToAdd
    }, null, 8, ["users-to-add", "users-to-invite", "onUpdateUsers"])
  ]))
}